<template>
    <div class="selected_histories">
      <DetailItem
          v-for="(history, history_key) in selected_history"
          :key="history_key"
          :history="history"
          @hide_info="hide_info"
      />
    </div>
</template>
<script>

import DetailItem from "./Item/Index.vue";

export default {
    name: 'LocationDetails',
    components: {
      DetailItem
    },
    props: ['selected_history'],

    computed: {
    },

    data() {
      return {}
    },
    created () {

    },
    methods:{
      hide_info(id){
        // console.log(id)
        this.$emit("hide_info", id)
      },
    }
}

</script>
<style lang="scss" scoped>
.selected_histories{
  padding: 0 10px;
  .history_card {
    border-radius: 10px;
    box-shadow: 0 2px 2px #ccc5b980;
    color: #252422;
    padding-bottom: 10px;
    position: relative;
    border: 1px solid #ccc;
    min-height: 85px;
    background-color: #f8f8f8;
    margin-bottom: 15px;
    overflow: hidden;
    &_header {
      font: 300 14px/20px "Roboto", Arial, sans-serif;
      text-transform: uppercase;
      position: relative;
      color: #000;
      background: #f4f3ef;
      padding: 1rem 2rem;
      border-radius: 10px 10px 0 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .phoca-flag{
        position: relative;
        width: 30px;
        height: 20px;
        margin: 0;
        box-shadow: none;
        border: none;
      }
      .mdi-close{
        //position: absolute;
        font-size: 16px;
        top: 10px;
        right: 15px;
      }
    }
    &_content {
      font: 300 12px/16px "Roboto", Arial, sans-serif;
      text-align: center;
      padding: 10px;
      .line{
        display: flex;
        align-content: center;
        justify-content: space-between;
        font-size: 14px;

        .line_wrap{
          display: flex;
          align-items: center;
          width: 50%;
          .value{
            width: 60px;
            margin-right: 10px;
          }
          .line{
            display: block;
            position: relative;
            width: calc(100% - 37px);
            background: #D5E7FF;
            height: 10px;
            border-radius: 2px;
            overflow-x: hidden;
            &::after{
              content: '';
              display: block;
              position: absolute;
              top: 0;
              left: 0;
              width: var(--lw);
              height: 10px;
              background: var(--c);
              border-radius: 2px 0 0 2px;
            }
          }
        }
        .response_table{
          padding: 0;
        }

        //.stats, .track{
        //  font-size: 16px;
        //}
      }
      //.content-item{
      //  display: flex;
      //  justify-content: center;
      //  align-items: flex-start;
      //  padding: 5px;
      //  &:nth-child(2n+1) {
      //    background-color: #e2ecdc;
      //  }
      //  .left{
      //    width: 40%;
      //  }
      //  .right{
      //    width: 60%;
      //    p{
      //      font-size: 12px;
      //      margin-bottom: 0;
      //    }
      //  }
      //  & > div{
      //    display: flex;
      //    align-items: center;
      //    justify-content: flex-start;
      //    font-size: 12px;
      //    height: 100%;
      //    span{
      //      text-overflow: ellipsis;
      //    }
      //  }
      //  .online_stats,
      //  .traffic_stats{
      //    text-align: start;
      //    .item{
      //      flex: 1;
      //      padding: 2px;
      //      border: 1px solid #999;
      //      margin-right: -1px;
      //      font-size: 14px;
      //    }
      //  }
      //  .traffic_stats{
      //    display: flex;
      //  }
      //}
    }
    &_footer {
      text-align: center;
      padding: 15px 0 5px;
      border-top: 1px solid #ccc;
    }
  }
}


</style>
